import { Flex, Image } from "@chakra-ui/react";
import companyLogoSrc from "../../../../../assets/img/esg-teal-emblem.png";
import * as React from "react";
import { useNavigate } from "react-router-dom";

function RedirectIconButton({ redirectTo }) {
  const navigate = useNavigate();

  return (
    <Flex
      height="25px"
      padding="2px 10px"
      justifyContent="center"
      backgroundColor="white"
      border="1px solid"
      borderColor={"#0C3136"}
      borderRadius="md"
      cursor="pointer"
      onClick={() => navigate(redirectTo)}
    >
      <Image src={companyLogoSrc} />
    </Flex>
  )
}

export default RedirectIconButton;